
















import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    props: {
        data: {
            type: Object as PropType<api.BrandCard>,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        // 关注品牌
        async putUserBrand(data) {
            let res;
            if (data.isConcerned) {
                res = await api.deleteUserBrand([{ brandId: data.brandId }]); // 取消品牌关注
                if (!api.error(res)) {
                    data.isConcerned = !data.isConcerned;
                    data.fansCount -= 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.putUserBrand, arguments: data }]);
                }
            } else {
                res = await api.putUserBrand([{ brandId: data.brandId }]); // 关注品牌
                if (!api.error(res)) {
                    data.isConcerned = !data.isConcerned;
                    data.fansCount += 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.putUserBrand, arguments: data }]);
                }
            }
        },
        toDetail() {
            this.$router.push({
                path: `/brand/${this.data.brandId}`,
            });
        },
    },
});
